import Repository from "../Repository";

const resource = "/deallist";
export default {
    get(id = null, params) {
        if (id) {
            return Repository.get(`${resource}/${id}`);
        } else {
            return Repository.get(`${resource}`, {params: params});
        }
    },
    create(json) {
        return Repository.post(`${resource}`, json);
    },
    update(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}`);
    },
    export(json) {
        return Repository.post(`${resource}/export`, json, {responseType: 'blob'});
    },
    getFilteredEntries(json) {
        return Repository.post(`${resource}/filter`, json);
    },
    getFilter(archived) {
        return Repository.get(`${resource}/filter?archived=${archived}`);
    },
    getUsers() {
        return Repository.get(`/users?deallist=1`);
    },
    getSeats() {
        return Repository.get(`/seats?deallist=1`);
    },
    getFormats() {
        return Repository.get(`/formats?deallist=1`);
    },
    getDevices() {
        return Repository.get(`/devices?deallist=1`);
    },
    getDealtypes() {
        return Repository.get(`/dealtypes?deallist=1`);
    },
    getPlacements() {
        return Repository.get(`/placements?deallist=1`);
    },
    getBrandings() {
        return Repository.get(`/brandings?deallist=1`);
    },
    getSalesoffices() {
        return Repository.get(`/salesoffices?deallist=1`);
    },
    getReportings() {
        return Repository.get(`/reportings?deallist=1`);
    },
    getAdvertisers() {
        return Repository.get(`/advertisers?deallist=1`);
    },


}